import {PLAN_NAME_PARTY_PASS, PLAN_NAME_PRO} from '~/common/fabric/routes/EventReview/constants';
import {getTimezone} from '~/common/utils';

export const previewTransformMiddleware = (store) => (next) => (action) => {
  next(action);
  const state = store.getState();
  const event = {...state.eviteEvent, rsvp: undefined};
  if (Object.keys(state.eviteEvent).length === 0) return state;
  const reminders = [];
  if (event.event_reminder_0) {
    reminders.push(event.event_reminder_0);
  }
  if (event.event_reminder_1) {
    reminders.push(event.event_reminder_1);
  }
  const pathPieces = window.location.pathname.split('/').slice(1);
  const inStep2 = pathPieces[2] === 'recipients';
  state.eventDetails = {
    ...state.eventDetails,
    ...state.details,
    ...state.details.address,
    title: state.details.title || 'Your event title',
    start: state.details.start?.toString() || '',
    end: state.details.end?.toString() || '',
    messageFromHost: state.details.notes,
    hostName: state.details.host || event.host_name,
    // biome-ignore lint/style/useNamingConvention: existing error
    _evite_event: event,
    shortLink: event.shortlink,
    eventId: event.id,
    eventType: event.event_type,
    status: event.status,
    usedAs: event.used_as,
    registriesData: event.gift_registries_data,
    // biome-ignore lint/style/useNamingConvention: existing error
    fabric_design_data: event.fabric_design_data,
    design: event.options.design,
    allowGuests: event.options.event_option_allow_guest_number,
    maxGuests: event.options.event_option_max_guest_number || 100,
    maxTotalGuests: event.options.event_option_max_guests || 750,
    privateGuestlist: event.options.event_option_private_guestlist,
    hasPassed: window.event_has_passed || false,
    origin: event.origin,
    isPremium: event.origin === 13 || event.is_fabric_premium,
    removeAds: event.remove_ads || false,
    reminders,
    widgets: event.widgets,
    videoId: event.event_videos_id,
    pristineHostMessage: !state.details.notes && inStep2,
  };

  const premiumDesign = event.options.design;
  state.premiumDesign =
    state.eventDetails.isPremium ||
    state.user.subscriptionPlanName === PLAN_NAME_PRO ||
    state.user.subscriptionPlanName === PLAN_NAME_PARTY_PASS
      ? {
          envelope: {
            name: {
              ...premiumDesign.name_style,
            },
            openBack: premiumDesign.envelope_flap_up,
            closedBack: premiumDesign.envelope_flap_down,
            closedFront: premiumDesign.envelope_front,
          },
          stamp: {
            image: premiumDesign.stamp_image,
          },
          background: {
            background: premiumDesign.background,
            color: premiumDesign.background_color,
            imageDesktop: premiumDesign.background_image_desktop,
            imageMobile: premiumDesign.background_image_mobile,
          },
          liner: {
            liner: premiumDesign.liner,
            image: premiumDesign.liner_image,
          },
          envelopeStickers: premiumDesign.envelope_fabric_stickers ?? null,
        }
      : {};

  const timezone = getTimezone();
  state.details.known_timezone_abbr = state.details.known_timezone_abbr || timezone?.timezoneAbbr;
  state.details.known_timezone_name = state.details.known_timezone_name || timezone?.timezoneId;

  next(action);
  return state;
};
